/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import { useDynamicFieldPosition } from "cms/fields/dynamic-field";
import { setFieldValueAtPath } from "data/store/reducers/model";
import { useCallback } from "react";
import { useDispatch } from "react-redux";

const useUpdateFieldSetting = () => {
    
    const dispatch = useDispatch();

    const fieldPosition = useDynamicFieldPosition();

    const updateFieldSetting = useCallback((setting, value) => {
        const path = [
            "fields", fieldPosition,
            "settings", setting
        ];
        const payload = { path, value };
        dispatch(setFieldValueAtPath(payload));
        
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fieldPosition]);

    return { updateFieldSetting };
    
};

export { useUpdateFieldSetting };
